module.exports = __webpack_public_path__ + "img/vanags_logo.f2c80248.png";